<div class="content">
    <div class="card">
        <div class="image" showleft>
            <img ngSrc="/images/home/story.webp" fill alt="{{appname}} lace fashion story">
        </div>
        <div class="texts">
            <h2 showright [showDelay]="100">Lace that feels soft, looks unforgettable.</h2>
            <p showright [showDelay]="200">At {{appname}}, we believe lace is more than a detail — it’s a feeling. Our
                tops are crafted with soft
                textures, flattering silhouettes, and romantic touches that make you feel confident, feminine, and
                completely you.</p>
            <a matButton="outlined" routerLink="/about-us" aria-label="{{appname}} story" showright
                [showDelay]="300">Discover Our Story</a>
        </div>
    </div>
</div>